import axios from '@/services/axios-auth-wrapper';
import { saveAs } from 'file-saver';

const url = process.env.VUE_APP_CONVERSABILITY_API_URL + '/api/presentation/';
const excelUrl = process.env.VUE_APP_CONVERSABILITY_API_URL + '/api/workbook/';

class ExporterService {
    async exportPPTX (presentationRequest) {
        let pptxResponse = await axios.post(url, presentationRequest, { responseType: 'blob' });
        saveAs(pptxResponse.data, presentationRequest.ResponseFileName);
    }

    async exportToExcel (workbookRequest) {
        let workbookResponse = await axios.post(excelUrl, workbookRequest, { responseType: 'blob' });
        saveAs(workbookResponse.data, workbookRequest.ResponseFileName);
    }
};

export const exporterService = new ExporterService();
